import React from "react";
import AnimatedSection from "./AnimatedSection";

export default function Policy() {
  return (
    <section className="bg-black text-white py-16 px-6 md:px-16">
      {/* Title */}
      <AnimatedSection className="text-center" delay={0.08}>
        <h1 className="text-3xl font-extrabold text-[#FF512F] my-6">
          Privacy Policy & Terms
        </h1>
      </AnimatedSection>

      {/* Scrollable Content */}
      <AnimatedSection className="max-w-6xl mx-auto" delay={0.16}>
        <div className="bg-[#0c0c0c] rounded-2xl shadow-lg p-2 md:p-12 overflow-y-auto max-h-[75vh] custom-scroll">
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          I. INTRODUCTION TO AND ACCEPTANCE OF THE TERMS Welcome, and thank you
          for choosing Hunt Share Live. This Terms of Service and User Agreement
          (“Agreement”), which also includes and incorporates our Privacy
          Policy, is a legally binding agreement between Hunt Share Live
          (“Company”, “we”, “our”, or “us”) and you (“you”, “user”) governing
          your use of the Hunt Share Live mobile application (the “App”), any
          associated client software (the “Software”), the
          https://www.livehuntshare.com website (the “Site”), and all related
          internet services and platforms (collectively, the “Services”) as a
          registered user (“Registered User”). Unless you accept this Agreement,
          you have no right or authorization to use any part of the Services
          that require you to be a Registered User. We may also offer additional
          products and services in connection with Hunt Share Live. Once you
          have registered as a user of Hunt Share Live, you may access these
          products and services with the same account credentials. Some
          additional products or services may have their own terms of service or
          user agreements, which you may need to accept before use. By checking
          the “I have read and agree to the Terms of Service and User Agreement”
          checkbox and completing the registration (sign‑up) process, or by
          continuing to use or access any of the Services as a Registered User,
          you agree and represent that: You are at least 18 years of age or the
          statutory age of majority in your country of nationality and
          residence, whichever is higher. You are not restricted from using the
          Services by law, contract, or by us. You fully agree with the terms
          and conditions set forth in this Agreement. Where required, your legal
          guardian has reviewed and consented to this Agreement and agreed to be
          responsible for any of your liabilities arising from its use. Your
          fundamental rights as a Registered User of the Services are set forth
          in this Agreement. We strongly encourage you to read all terms and
          conditions carefully. This Agreement includes a requirement to resolve
          disputes by binding arbitration on an individual basis. The venue for
          such arbitration may be outside your country of residence. Due to
          evolving technologies, changes in laws and regulations, and shifting
          market conditions, Hunt Share Live reserves the right, at its sole
          discretion, to modify or revise this Agreement at any time. To the
          extent permitted by applicable law, you agree to be bound by any such
          modifications or revisions. Any modified or revised version will
          become effective upon being posted to our Services (or at a later date
          if specified in that version). We may also provide notice to you
          through other reasonable means. Your continued use of the Services
          after such changes constitutes your acceptance of and consent to the
          updated Agreement. If you do not agree to any modification or
          revision, your sole remedy is to stop using the Services.
        </p>
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          II. USER RIGHTS AND LICENSES 1. Rights to Access the Services A. Live
          Hunt Share provides an online and mobile platform offering
          comprehensive software and network services. These include audio and
          video live streaming, multi‑stream hosting, in‑stream games, private
          and public rooms, gifting systems, music streaming, posting and social networking
          features, forums, messaging, and other interactive tools to connect
          and communicate with other users of the Services. B. Subject to your
          compliance with this Agreement, Hunt Share Live grants you a
          conditional, limited, revocable, non‑exclusive, non‑transferable,
          non‑sublicensable license to access and use the Services solely for
          your personal, non‑commercial use. You agree not to, and not to
          attempt to: i) Use the Services for any purpose not expressly
          permitted by this Agreement. ii) Attack, hack, disrupt, interfere
          with, reverse‑engineer, disassemble, or attempt to derive the source
          code of the Services. iii) Engage in any action that may infringe,
          harm, or jeopardize the lawful rights or interests of any person. iv)
          Copy, modify, adapt, create derivative works, distribute, license,
          sell, transfer, publicly display, perform, stream, broadcast, or
          otherwise exploit the Services or any part thereof, except as
          expressly permitted by this Agreement or authorized in writing by the
          Company. 2. License of the Software and the App A. The Hunt Share Live
          App and related Software are licensed, not sold, to you. They may
          contain copyrighted material and integrated or peripheral content. All
          rights not expressly granted under this Agreement remain with the
          Company. B. Subject to your compliance with this Agreement, the
          Company grants you a conditional, limited, revocable, non‑exclusive,
          non‑transferable, non‑sublicensable license to copy, install, use, and
          uninstall the App and Software on devices you own or control
          (including computers, smartphones, tablets, smart TVs, and wearable
          devices), solely for your personal, non‑commercial use. This Agreement
          also governs all updates, patches, and additional downloadable content
          provided by the Company. C. You may not rent, sell, transfer,
          redistribute, or sublicense the App or Software. If you sell or
          transfer your device to another party, you must first uninstall or log
          out of Hunt Share Live and remove all account‑related data. D. You
          agree not to exploit errors, bugs, or vulnerabilities in the App or
          Software, nor create, distribute, or use any programs, scripts, or
          tools intended to damage or interfere with the Services. 3. Use of
          Data You agree that Hunt Share Live may collect and use technical and
          related information — including details about your device, operating
          system, network connection, and installed software — for the purpose
          of delivering, maintaining, and improving the Services. This may also
          be used for customer service, technical support, and product
          development. Data will only be shared in a form that does not
          personally identify you, unless otherwise required by law or you have
          provided consent. 4. No Other Rights Granted Except for the rights and
          permissions expressly granted in this Agreement, no other licenses or
          rights are provided to you, whether by implication or otherwise.
        </p>
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          III. USER ACCOUNT AND VERIFICATION 1. Your Account A. While some
          features of Hunt Share Live are available without registration, access
          to most advanced streaming, social, and monetization features requires
          you to create a Hunt Share Live Account (“Account”). B. When creating
          an Account, you may be prompted to provide certain personal details or
          log in with an existing account. You agree that all information you
          provide will be accurate, current, and complete, and that you will
          promptly update it if changes occur. You must not misrepresent your
          age or provide false details to bypass our access requirements. You
          will become a Registered User once your Account is successfully
          created. C. You may select a unique username and display name in
          accordance with our Platform Rules. We reserve the right to restrict
          certain names for legal, safety, or community protection purposes,
          including prevention of impersonation, harassment, or intellectual
          property infringement. D. You are solely responsible for keeping your
          login credentials — including your account ID, username, and password
          — secure. You agree to immediately notify us if you suspect
          unauthorized use of your Account. Hunt Share Live is not responsible
          for any loss or damage resulting from unauthorized access to your
          credentials. E. If you lose your password, you may request account
          recovery following our verification procedures. While we will make
          every effort to restore access, we cannot guarantee recovery in all
          cases, nor can we prevent fraudulent claims by imposters who provide
          matching information. F. All Hunt Share Live Accounts remain the
          property of the Company. You are granted the right to use your Account
          while it remains active. Your Account must only be used by you, and
          may not be sold, transferred, rented, loaned, or gifted to anyone
          else. If we detect unauthorized use or a dispute over account
          ownership, we reserve the right to suspend, reclaim, or terminate the
          account without prior notice. Any resulting loss of communication
          history, data, or virtual assets will be the sole responsibility of
          the user. G. We may suspend, terminate, or reclaim inactive accounts
          or accounts that violate our Terms, community guidelines, or legal
          requirements. Such action may be taken with or without notice and
          without liability to you. 2. Real‑Name Verification A. To access
          certain features (including but not limited to monetization,
          withdrawals, agency management, or hosting privileges), you may be
          required to complete a Real‑Name Verification process as mandated by
          applicable laws or platform regulations. This may include submitting
          personal identification details such as your full legal name,
          government‑issued ID or passport number, and a verified phone number.
          We will handle this information as described in our Privacy Policy. B.
          We may also use biometric verification methods — such as facial
          recognition, fingerprint scanning, or other technologies — to confirm
          your identity. You must personally complete the biometric verification
          process without substitution by another individual. C. By submitting
          your real‑name or biometric data, you confirm that all information is
          truthful, accurate, and your own. False or fraudulent submissions, or
          attempts to bypass verification with an imposter, may result in
          immediate account suspension, permanent termination, and potential
          legal consequences. You will be responsible for any loss, damage, or
          liability caused by providing false information.
        </p>
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          IV. LAWFUL AND PROPER USAGE OF THE SERVICES When using Live Hunt
          Share, you must follow our Platform Rules, Codes of Conduct, and
          Community Guidelines (“Regulations”) to ensure a safe, respectful, and
          lawful environment. 1. Platform Rules We may publish specific rules
          for certain features or activities (e.g., streaming, chatrooms,
          games). These rules explain how to use the feature, what is allowed,
          and the consequences of violations. New rules or updates will be
          posted online, and your continued use means you accept them. 2. Codes
          of Conduct You must not use the Services to: Share illegal, obscene,
          pornographic, violent, or harmful content. Harass, threaten,
          impersonate, or defame others. Violate copyrights, trademarks, privacy
          rights, or other legal rights. Spread malware, phishing attempts, or
          harmful programs. Cheat, hack, or exploit bugs for unfair advantage.
          Share personal information of others without consent. Abuse customer
          support or make false reports. 3. Community Guidelines You are
          encouraged to: Be respectful and friendly. Create positive,
          high-quality content. Engage with the community in a constructive way.
          You must not: Do anything illegal or promote illegal activities. Share
          harmful content involving minors. Upload sexually explicit, violent,
          hateful, or self-harm content. Threaten or blackmail anyone. Spread
          malicious content like viruses or spyware. Steal or alter accounts or
          data. Organize harassment campaigns or spam others. Create deepfake or
          misleading content. 4. Consequences of Violations Breaking these rules
          may lead to: Removal of content. Loss of in-app currency or items.
          Account suspension or permanent ban. Restriction of certain features.
          Public notice of violation. Serious or repeated violations may result
          in stronger penalties, and you may be legally responsible for damages.
        </p>
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          V. INTELLECTUAL PROPERTY RIGHTS 1. Ownership All designs, text,
          graphics, videos, music, software, and other materials in Live Hunt
          Share (“Platform Materials”) are owned by us or our licensors. You may
          not copy, modify, distribute, sell, or exploit Platform Materials
          without our written consent. User-generated content (“UGC”) remains
          your property, but by posting it, you grant us a worldwide,
          royalty-free license to use, display, distribute, and promote it in
          connection with the Services. We may remove UGC without notice if it
          violates our rules or the law. 2. Copyright Complaints If you believe
          your copyrighted work is used without permission: Email us at
          copyright@livehuntshare.com with: Your signature (physical or
          electronic). Description of the work. Location of the infringing
          material. Your contact info. Statement of good faith belief of
          infringement. Statement under penalty of perjury confirming your
          claim. If your UGC is removed and you believe it’s an error, you may
          send a counter‑notice with similar details.
        </p>
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          VI. VIRTUAL CURRENCIES & VIRTUAL ITEMS We may offer Virtual Currency
          and Virtual Items for purchase using real money. All purchases are
          final — no refunds, transfers, or exchanges unless required by law or
          at our discretion. You may not buy, sell, or trade Virtual
          Currency/Items outside of Hunt Share Live. Doing so may result in
          confiscation, account suspension, or legal action. We may change,
          manage, or remove Virtual Currency/Items at any time without
          liability. You receive only a limited license to use Virtual
          Currency/Items within the Services — you do not own them.
        </p>
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          VII. FEES, EARNINGS & PAYMENTS 1. Fees Basic use of Hunt Share Live is
          free. Some features, Virtual Currency, or Virtual Items may require
          payment. Prices are shown in the app before purchase. 2. Earnings You
          may earn income from activities, sponsorships, or other users.
          Earnings may first appear as virtual credits in your account. You can
          withdraw these credits only if: You are 18+ (or above your country’s
          legal age). You have passed real‑name verification. Earnings are from
          legal activities. You are not in breach of our Terms or Rules.
          Withdrawals may be blocked if conditions aren’t met. Compliance does
          not guarantee withdrawal approval. 3. Payments Payments are processed
          according to our posted Platform Rules. 4. Taxes You are responsible
          for paying all taxes, fees, or charges related to your earnings. 5. No
          Refunds Purchases of Virtual Currency or Virtual Items (e.g.,
          Diamonds) are non‑refundable unless required by law.
        </p>
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          VIII. DISCLAIMERS OF WARRANTIES No Guarantees – Hunt Share Live and
          its materials are provided “as is”, without any express or implied
          warranties, including merchantability, fitness for a purpose, title,
          or non‑infringement. We do not guarantee the Services will be
          error‑free, secure, or uninterrupted. UGC Responsibility – We are not
          responsible for user‑generated content (UGC) or any offensive,
          illegal, or harmful behavior from third parties. All risks remain with
          you. Account Actions – If we suspend, restrict, or terminate your
          account under these Terms or the law, we are not liable for any
          resulting loss (including data, communication, or virtual assets). No
          Liability in Certain Cases – We are not responsible for losses caused
          by: Legal or government‑ordered disclosure of personal data Sharing
          your password or account Hacking, viruses, telecom failures Force
          majeure events beyond our control IX. LIMITATION OF LIABILITY To the
          maximum extent allowed by law, Hunt Share Live is not liable for
          indirect, incidental, special, punitive, or consequential damages
          (including loss of profit or data). Our maximum liability is the
          greater of: (A) the total you paid us in the last 3 months, or (B)
          $100 USD. Some jurisdictions do not allow these exclusions — in such
          cases, we will comply with applicable law. X. TERMINATION &
          MODIFICATION 1. Termination / Interruption You can request account
          deletion anytime by contacting support. We may terminate your account
          or access to the Services for violations of these Terms or at our
          discretion. Termination may result in loss of your account, data, and
          any virtual items/currency without compensation. We may deny service
          without notice for any reason. Scheduled or unscheduled maintenance
          may cause temporary service interruptions. 2. Modifications We may
          update, modify, reprice, or discontinue the Services or parts of them
          at any time. If you disagree with changes, stop using the Services.
          Continuing to use them means you accept the changes.
        </p>
        <p className="mb-2 leading-relaxed text-gray-300 text-xs">
          XI. GOVERNING LAW & DISPUTE RESOLUTION 1. Governing Law This Agreement
          is governed by the laws of Singapore, regardless of your location. The
          UN Convention on the International Sale of Goods (1980) does not
          apply. 2. Dispute Resolution Any dispute will be resolved by
          arbitration at the Singapore International Arbitration Centre (SIAC),
          under SIAC rules. Seat of arbitration: Singapore. Language: English or
          Chinese. If arbitration is invalid/unavailable, disputes will be
          handled by Singapore courts. We may seek injunctions or equitable
          relief without posting a bond if you breach this Agreement. 3. User
          Disputes You are solely responsible for your interactions with other
          users. We may, but are not required to, assist in resolving disputes.
          XII. ADDITIONAL PROVISIONS Your Responsibility – You must provide your
          own devices, internet, and pay any related costs. Notices – We may
          send notices via in‑app messages, email, SMS, or website
          announcements. Notices from you must be sent to our official contact
          details. Entire Agreement – This Agreement is the entire understanding
          between you and us. No Waiver – Our failure to enforce any right is
          not a waiver of that right. Severability – If part of this Agreement
          is invalid, the rest remains enforceable. Assignment – You cannot
          transfer this Agreement without our consent. We may assign freely.
          Headings – Section titles are for convenience only. Drafting – You
          agree this Agreement is not interpreted against us for having drafted
          it. Survival – Certain clauses (e.g., IP rights, limitation of
          liability) survive termination. Third‑Party Services & Ads We use
          third‑party services but are not responsible for their actions or your
          dealings with them. The Service may display ads or send you
          promotional messages as permitted by law. No third party gains rights
          from this Agreement. International Use & Export Control If this
          Agreement is translated, the English version prevails. Our software is
          subject to Singapore export laws and cannot be exported to prohibited
          countries or individuals. You must comply with all local laws and U.S.
          export restrictions if applicable.
        </p>
        </div>
      </AnimatedSection>

      {/* Back to Top Button */}
      <AnimatedSection delay={0.24}>
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 bg-[#FF512F] hover:bg-[#e3b678] text-white px-4 py-2 rounded-full shadow-md hover:shadow-[#FF512F]/50 transition-all duration-300"
        >
          ↑ Top
        </button>
      </AnimatedSection>
    </section>
  );
}
